import { EssityColumnProps } from '@components/shared/paginatedEssityTable/GridHelper';
import PaginatedEssityTable from '@components/shared/paginatedEssityTable/PaginatedEssityTable';
import { SieveModel } from '@components/shared/paginatedEssityTable/SieveModels';
import { TableWithTitle } from '@components/shared/TableWithTitle';
import { ajaxByUser } from '@helper/api';
import { useRootData } from '@hooks/hook';
import { getEssityApiClient } from '@services/EssityApi';
import {
	PharmacyAllForBulkInvitationOptionalParams,
	PharmacyBulkInvitationDto,
} from '@services/src/models';
import { Button, Divider } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { IGridStore } from 'stores/GridStore';

import { GetPharmaciesInvitationTableColumns } from './GetPharmaciesInvitationTableColumns';
import styles from './styles/BulkInvitation.module.less';

export const BulkInvitationView = observer(() => {
	const [isBusy, setIsBusy] = useState<boolean>(false);

	const gridStore: IGridStore = useRootData((store) => store.gridStore);

	const columns: EssityColumnProps<PharmacyBulkInvitationDto>[] = GetPharmaciesInvitationTableColumns();

	const handleSend = () => {
		const selectedIds = gridStore.getSelectedKeys() as string[];
		setIsBusy(true);
		ajaxByUser('Successfully sent invitations.', () =>
			getEssityApiClient().then((api) =>
				api.pharmacy
					.bulkInvite({
						body: {
							pharmacyIds: selectedIds,
						},
					})
					.then(() => {
						gridStore.clearSelection();
						gridStore.searching.set(true);
					})
					.finally(() => {
						setIsBusy(false);
					})
			)
		);
	};

	return (
		<>
			<Divider />
			<TableWithTitle title="Bulk sending of invitations - select pharmacies.">
				<PaginatedEssityTable<PharmacyBulkInvitationDto>
					className={styles.table}
					columns={columns}
					gridName="pharmacies-invitation"
					hasRowSelection={true}
					clearSelectionOnSearching={false}
					showClearFilterButton={true}
					hidePersonalizationSettings={true}
					getRowKey={(r: PharmacyBulkInvitationDto) => r.id!}
					detailsUrl="pharmacies/details"
					getPagedResult={async (sieve: SieveModel, abortSignal) => {
						const parameters: PharmacyAllForBulkInvitationOptionalParams = {
							page: sieve.page,
							pageSize: sieve.pageSize,
							sorts: sieve.sorts,
							filters: sieve.filters,
							abortSignal: abortSignal,
						};
						const api = await getEssityApiClient();
						return await api.pharmacy.allForBulkInvitation(
							parameters
						);
					}}
				/>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						marginTop: '16px',
					}}
				>
					<Button
						type="primary"
						size="large"
						shape="round"
						disabled={isBusy || gridStore.selectedKeys.length === 0}
						onClick={handleSend}
					>
						Send invitations ({gridStore.selectedKeys.length})
					</Button>
				</div>
			</TableWithTitle>
		</>
	);
});
